import * as _ from 'lodash';

interface IPlanADaySetup {
  mobile_url: string;
  kiosk_url: string;
}


export class PhcApp {

  id: number = 0;
  ID: number = 0;
  version: number = 0;
  location: { city: string; country: string; weather_background: string; scale: 'Celsius' | 'Fahrenheit' };
  weather: string;
  header_logo: string = '';
  logos: {
    [key: string] : PhcAppImage
  };
  home_headline: string = '';
  home_welcome_msg: string = '';
  photo_frame: string = '';
  home_slider: Array<PhcAppImage> = [];
  home_banners: Array<PhcAppBanner> = [];
  home_menu?: PhcAppMenu;
  setting_pass: string = '';
  menus: Array<PhcAppMenu> = [];
  galleries: Array<PhcAppGallery> = [];
  menu_items: Array<PhcAppMenuItem> = [];
  modules: Array<PhcAppModule> = [];
  in_room_dining?: any;
  room_service?: any;
  review_menu?: PhcAppMenu|PhcAppMenuItem;
  articles: Array<PhcArticle>;
  planaday: IPlanADaySetup;
  tabs: Array<PhcAppTab> = [];
  planaday_subdomain: string;

  require_signin: boolean;
  signin_message: string;

  public allImages: Array<string> = [];

  constructor(appData?){
    if (appData) {
      this.updateAppData(appData);
    }
  }

  getArticle(id){
    return _.find(this.articles, { id })
  }

  getArticles(ids){
    return ids.map(id => this.getArticle(id));
  }

  getGallery(id){
    return _.find(this.galleries, { id })
  }

  getGalleries(ids){
    return ids.map(id => this.getArticle(id));
  }

  getMenus(menuIds){
    return menuIds.map(id => this.getMenu(id));
  }

  getMenu(id){
    return _.find(this.menus, { id: id });
  }

  getMenuItems(menuIds){
    return menuIds.map(id => this.getMenuItem(id));
  }

  getMenuItem(id){
    return _.find(this.menu_items, { id: id });
  }

  getMenuOrItem(id){
    return this.getMenuItem(id) || this.getMenu(id);
  }

  getMenusOrItems(ids){
    return ids.map(id => this.getMenuOrItem(id));
  }

  getModules(menuIds){
    return menuIds.map(id => this.getModule(id));
  }

  getModule(id): PhcAppModule{
    return _.find(this.modules, { id: id });
  }

  getIrdMenuItem(id){
    return _.find(this.in_room_dining.ird_menu_items, { id: id });
  }

  getIrdMenuItems(ids){
    return ids.map(id => this.getIrdMenuItem(id));
  }

  getIrdMenu(id){
    return _.find(this.in_room_dining.ird_menus, { id: id });
  }

  getAmenities(ids){
    return ids.map(id => this.getAmenity(id));
  }

  getAmenity(id){
    return _.find(this.room_service, { ID: id });
  }

  updateAppData(appData){
    console.log(appData);

    if (!appData) { return; }


    let menuItems = [],
        menus = [],
        modules = [],
        articles = [],
        tabs = [],
        homeBanners = [],
        galleries = [];

    if(appData.menu_items && appData.menu_items.length){
      menuItems = appData.menu_items
        .filter(item => item && item.ID)
        .map(item => new PhcAppMenuItem(item));
    }

    if(appData.menus && appData.menus.length){
      menus = appData.menus
        .filter(menu => menu && menu.ID)
        .map(menu => new PhcAppMenu(menu));
    }

    if(appData.galleries && appData.galleries.length){
      galleries = appData.galleries
        .filter(gallery => gallery && gallery.ID)
        .map(gallery => new PhcAppGallery(gallery));
    }

    if(appData.modules && appData.modules.length){
      modules = appData.modules.map(module => new PhcAppModule(module));
    }

    if(appData.articles && appData.articles.length){
      articles = appData.articles.map(article => new PhcArticle(article));
    }

    if(appData.tabs && appData.tabs.length){
      tabs = appData.tabs.map(tab => new PhcAppTab(tab));
    }

    if(appData.home_banners && appData.home_banners.length){
      homeBanners = appData.home_banners.map(banner => new PhcAppBanner(banner));
    }

    if(appData.in_room_dining){
      this.in_room_dining = new PhcInRoomDining(appData.in_room_dining);
    }

    this.menu_items = menuItems;
    this.menus = menus;
    this.galleries = galleries;
    this.modules = modules;
    this.articles = articles;
    this.tabs = tabs;

    this.planaday = appData.planaday;
    this.id = appData.ID;
    this.ID = appData.ID;
    this.version = appData.version;
    this.location = appData.location;
    this.weather = appData.weather;
    this.header_logo = appData.header_logo;
    this.photo_frame = appData.photo_frame;
    this.logos = appData.logos;
    this.home_headline = appData.home_headline;
    this.home_welcome_msg = appData.home_welcome_msg;
    this.home_slider = appData.home_slider;
    this.home_banners = appData.home_banners;
    this.home_menu = this.getMenu(appData.home_menu);
    this.planaday_subdomain = appData.planaday_subdomain;
    this.setting_pass = appData.setting_pass;

    this.require_signin = appData.require_signin;
    this.signin_message = appData.signin_message;


    this.room_service = appData.room_service;
    this.review_menu = this.getMenu(appData.review_menu) || this.getMenuItem(appData.review_menu);

    // Store thumbnails for preload

    const menuThumbs = this.menus.map(menu => {
      return (menu.thumbnail && menu.thumbnail.url) ? menu.thumbnail.url.sizes.medium : '';
    });

    const itemThumbs = this.menu_items.map(item => {
      return (item.thumbnail && item.thumbnail.url) ? item.thumbnail.url.sizes.medium : '';
    });

    this.allImages = this.allImages.concat(menuThumbs, itemThumbs).filter(url => url && url.length);


    console.log(this);

  }

  private objectKeysToCamelCase(snake_case_object) {
    let camelCaseObject = {};
    if(_.isArray(snake_case_object)){
      camelCaseObject = [];
    }
    _.forEach(
      snake_case_object,
      (value, key) => {
        if (_.isPlainObject(value) || _.isArray(value)) {     // checks that a value is a plain object or an array - for recursive key conversion
          value = this.objectKeysToCamelCase(value);               // recursively update keys of any values that are also objects
        }
        camelCaseObject[_.camelCase(key)] = value;
      }
    );
    return camelCaseObject;
  };

}


export class PhcAppModule{
  id: string;
  moduleKey: string;
  moduleTitle: string;

  constructor(module){
    this.id = module.ID;
    this.moduleKey = module.module_id;
    this.moduleTitle = module.module_title;
  }

}


export class PhcAppMenu{

  readonly type = 'menu';

  id: number;
  title: string;
  icon: string;
  description: string;
  thumbnail: PhcThumbnail;
  submenus: Array<PhcAppSubmenu> = [];
  items: Array<number> = [];
  banners: Array<PhcAppBanner> = [];

  constructor(menu){
    this.id = menu.ID;
    this.title = menu.title || '';
    this.icon = menu.icon || '';
    this.description = menu.description || '';

    this.thumbnail = new PhcThumbnail(menu.thumbnail);
    if(menu.items && menu.items.length) {
      this.items = menu.items;
    }

    if (menu.submenus && menu.submenus.length) {
      this.submenus = menu.submenus.filter(sub => sub).map(sub => new PhcAppSubmenu(sub));
    }

    if (menu.banners && menu.banners.length) {
      this.banners = menu.banners.filter(sub => sub && sub.ID).map(bn => new PhcAppBanner(bn));
    }
  }

}

export class PhcAppTab {
  name: string;
  icon: string;
  link: PhcLink;
  constructor(tab) {
    this.name = tab.name;
    this.icon = tab.icon;
    this.link = new PhcLink(tab.link);
  }
}


export class PhcAppBanner{

  id: number;
  image: PhcAppImage;
  video: string;
  link: PhcLink;
  duration: number;

  constructor(banner){
    this.id = banner.ID || banner.id;
    this.image = banner.image;
    this.video = banner.video;
    this.link = new PhcLink(banner.link);
    this.duration = parseInt(banner.duration) * 1000;

  }
}

export class PhcAppSubmenu{

  title: string;
  description: string;
  items: Array<number>;
  banners: Array<PhcAppBanner> = [];

  constructor(sub) {
    this.title = sub.title || '';
    this.description = sub.description || '';
    this.items = sub.items;

    if (sub.banners && sub.banners.length) {

      this.banners = sub.banners.filter(sub => sub && sub.ID).map(bn => new PhcAppBanner(bn));
    }
  }

}

export class PhcAppMenuItem{

  readonly type = 'item';

  id: number;
  title: string;
  icon: string;
  description: string;
  link: PhcLink;
  thumbnail: PhcThumbnail;

  constructor (item) {
    this.id = item.ID;
    this.title = item.title || '';
    this.icon = item.icon || '';
    this.description = item.description;
    this.link = new PhcLink(item.link);
    this.thumbnail = new PhcThumbnail(item.thumbnail);
  }
}


export class PhcLink{
  type: string;
  webpageUrl: string;
  webpageTarget: string;
  menuId: number;
  moduleId: number;
  module: any;
  articleId: number;
  galleryId: number;


  constructor(link){
    this.type = link.type;


    if(this.type === 'module') {
      this.moduleId = link.module.id;
      this.module = link.module;
    } else if(this.type === 'webpage') {
      this.webpageUrl = link.webpage_url;
      this.webpageTarget = link.webpage_target;
    } else if(this.type === 'menu'){
      this.menuId = link.menu_id;
    } else if(this.type === 'article') {
      this.articleId = link.article_id;
    } else if(this.type === 'gallery') {
      this.galleryId = link.gallery_id;
    }
  }

  isPlanADay() {
    return this.isWebpage() && this.webpageUrl.indexOf('.planaday.') > -1;
  }

  isWebpage(){
    return this.type === 'webpage';
  }

  isMenu(){
    return this.type === 'menu';
  }

  isModule() {
    return this.type === 'module';
  }

  isArticle(){
    return this.type === 'article';
  }

  isGallery(){
    return this.type === 'gallery';
  }

}

export class PhcContent{

  constructor(content){

  }
}

export class PhcThumbnail{
  url: PhcAppImage;
  darken: number = 0;

  constructor(item){
    if(item && item.url && item.url.sizes){
      this.url = item.url || {};
      this.darken = parseInt(item.darken || 0) / 100;
    }
  }

  darkenStyle(){
    return {
      boxShadow: `inset 0 0 0 1000px rgba(0,0,0,${ this.darken })`,
    }
  }

}

export interface IPhcInRoomDiningFee {
  fee_amount: number;
  fee_label: string;
  fee_type: 'dollar' | 'percent';
}

export class PhcInRoomDining{

  enabled = false;
  ird_menu_items = [];
  ird_menus = [];
  order_recipient_email = '';
  order_recipient_phone = '';
  fees: IPhcInRoomDiningFee[] = [];

  constructor(ird){
    if(ird && ird.enabled){
      this.enabled = ird.enabled;
      this.ird_menu_items = ird.ird_menu_items.map(item => new PhcInRoomDiningMenuItem(item));
      this.ird_menus = ird.ird_menus.map(menu => new PhcInRoomDiningMenu(menu));
      this.order_recipient_email = ird.order_recipient_email;
      this.order_recipient_phone = ird.order_recipient_phone;
      this.fees = ird.fees ? ird.fees.map(fee => ({...fee, fee_amount: parseInt(fee.fee_amount, 10)})) : []
    }

  }

}

export class PhcInRoomDiningMenuItem{

  id: number;
  description = '';
  modifiers = [];
  prices = [];
  thumbnail: PhcThumbnail;
  title = '';

  constructor(item){
    this.id = item.ID;
    this.description = item.description;
    this.modifiers = item.modifiers;
    this.prices = item.prices;
    this.thumbnail = new PhcThumbnail(item.thumbnail);
    this.title = item.title;
  }
}

export class PhcInRoomDiningMenu{

  id: number;
  availability: any;
  description = '';
  parent_app: number;
  sections = [];
  thumbnail: PhcThumbnail;
  title = '';

  constructor(menu){
    this.id = menu.ID;
    this.availability = menu.availability;
    this.description = menu.description;
    this.parent_app = menu.parent_app;
    this.sections = menu.sections;
    this.thumbnail = new PhcThumbnail(menu.thumbnail);
    this.title = menu.title;
  }
}

export class PhcArticle{
  id: number;
  post_author: string;
  post_date: string;
  post_date_gmt: string;
  post_content: string;
  post_title: string;
  post_excerpt: string;
  post_status: string;
  comment_status: string;
  ping_status: string;
  post_password: string;
  post_name: string;
  to_ping: string;
  pinged: string;
  post_modified: string;
  post_modified_gmt: string;
  post_content_filtered: string;
  post_parent: number;
  guid: string;
  menu_order: number;
  post_type: string;
  post_mime_type: string;
  comment_count: string;
  filter: string;
  featured_image: string;

  constructor(article){
    this.id = article.ID;
    this.post_author = article.post_author;
    this.post_date = article.post_date;
    this.post_date_gmt = article.post_date_gmt;
    this.post_content = article.post_content;
    this.post_title = article.post_title;
    this.post_excerpt = article.post_excerpt;
    this.post_status = article.post_status;
    this.comment_status = article.comment_status;
    this.ping_status = article.ping_status;
    this.post_password = article.post_password;
    this.post_name = article.post_name;
    this.to_ping = article.to_ping;
    this.pinged = article.pinged;
    this.post_modified = article.post_modified;
    this.post_modified_gmt = article.post_modified_gmt;
    this.post_content_filtered = article.post_content_filtered;
    this.post_parent = article.post_parent;
    this.guid = article.guid;
    this.menu_order = article.menu_order;
    this.post_type = article.post_type;
    this.post_mime_type = article.post_mime_type;
    this.comment_count = article.comment_count;
    this.filter = article.filter;
    this.featured_image = article.featured_image;
  }
}

export interface IPhcGalleryAlbum {
  name: string;
  images: PhcAppImage[];
}

export class PhcAppGallery {
  id: number;
  title: string;
  description: string;
  albums: IPhcGalleryAlbum[];
  constructor(gallery) {
    this.id = gallery.ID;
    this.title = gallery.title;
    this.description = gallery.description;
    this.albums = gallery.albums;

  }
}



// WEBPACK FOOTER //
// ./src/classes/phc-app/phc-app.ts